module.exports = __webpack_public_path__ + "src/assets/img/empty.1a413db6.png";